// extracted by mini-css-extract-plugin
module.exports = {"statusTagLabel":"preference-status-tag_statusTagLabel__G6B4P"};